// src/index.js (Corrected Version)
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// All the Firebase initialization has been moved to './firebase.js'
// and is imported by the components that need it.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);